<script setup lang="ts">
const ones = new Array('one', 'two', 'three', 'four');
</script>

<template>
  <div class="w-full">
    <UserInterfaceGenericSkeleton
      class="mb-2 mt-7"
      width-class="w-[50vw] md:w-[25vw]"
      height-class="h-6"
      rounded-class="rounded-md"
    />

    <div class="category-masonry">
      <div v-for="(one, index) in ones" :key="index" :class="one">
        <UserInterfaceGenericSkeleton />
      </div>
    </div>
  </div>
</template>

<style scoped></style>
